export const isTablet = () => {
  const userAgent = navigator.userAgent
  // iPadOS 13+ reports a desktop Safari user agent, so detect it via touch support
  const isIPadOS = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1
  // Android tablets omit the "Mobile" token that Android phones include
  const isAndroidTablet =
    /Android/i.test(userAgent) && !/Mobile/i.test(userAgent)

  return (
    isIPadOS ||
    isAndroidTablet ||
    /iPad|Tablet|PlayBook|Silk|Kindle/i.test(userAgent)
  )
}

export const isMobile = () => {
  return (
    !isTablet() &&
    /Mobi|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    )
  )
}

export const isTouchDevice = () => {
  return isMobile() || isTablet()
}
